module.exports = "/static/media/glyphicons-halflings-regular.fa277232.woff";